// 定义状态
const state = { // 要设置全局访问的state对象
  showFooter: true, //  要设置的初始属性值
  changableNum: 10
}

// 定义getters 如果设计到的业务太多  也可以将其单独抽取出来形成一个getters.js文件
const getters = {
  isShow(state) {
    return state.showFooter
  },
  getChangeNum(state) {
    return state.changableNum
  }
}

const mutations = {
  show(state) {
    state.showFooter = true
  },
  hidden(state) {
    state.showFooter = false
  },
  newNum(state, sum) {
    state.changableNum += sum
  }
}
// actions里面的方法可以用来触发mutations里面的方法
const actions = {
  hiddenFooter(context) { // 自定义触发mutations里函数的方法,context与store实例具有相同的属性和方法
    context.commit('hide')
  },
  showFooter(context) {
    context.commit('show')
  },
  getNewNum(context, num) { // num是要变化的形参
    context.commit('newNum', num)
  }

}

export default {
  namespaced: true, // 用于在全局引用此文件里面的方法标识一个的文件名
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/testStatus.js